import PropTypes from 'prop-types'
import { Handle, Position, useUpdateNodeInternals } from '@xyflow/react'
import { useEffect, useRef, useState, useContext } from 'react'

// Tailwind doesn't provide Tooltip, use a custom implementation or library
import { FlowContext } from '../../store/context/ReactFlowContext'
import { isValidConnection } from '../../utils/genericHelper'
import { Dropdown } from '../../components/dropdown/Dropdown'

// Custom Tooltip implementation or use a library like @headlessui/react

// ===========================|| NodeOutputHandler ||=========================== //

const NodeOutputHandler = ({ outputAnchor, data, disabled = false }) => {

    const ref = useRef<any>(null)
    const updateNodeInternals = useUpdateNodeInternals()
    const [position, setPosition] = useState(0)
    const [dropdownValue, setDropdownValue] = useState(null)
    const { reactFlowInstance } = useContext(FlowContext)

    useEffect(() => {
        if (ref.current) {
            setTimeout(() => {
                setPosition(ref.current.offsetTop + ref.current.clientHeight / 2)
                updateNodeInternals(data.id)
            }, 0)
        }
    }, [data.id, ref, updateNodeInternals])

    useEffect(() => {
        setTimeout(() => {
            updateNodeInternals(data.id)
        }, 0)
    }, [data.id, position, updateNodeInternals])

    useEffect(() => {
        if (dropdownValue) {
            setTimeout(() => {
                updateNodeInternals(data.id)
            }, 0)
        }   
    }, [data.id, dropdownValue, updateNodeInternals])

    return (
        <div ref={ref} className="clear-right">
            {outputAnchor.type !== 'options' && !outputAnchor.options && (
                <>
                    <div className="group">
                        <div className="absolute right-0 hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2">
                            {outputAnchor.type}
                        </div>
                        <Handle
                            type='source'
                            position={Position.Right}
                            key={outputAnchor.id}
                            id={outputAnchor.id}
                            isValidConnection={(connection) => isValidConnection(connection, reactFlowInstance)}
                            style={{
                                height: 10,
                                width: 10,
                                backgroundColor: data.selected ? 'theme-primary-color' : 'theme-secondary-color',
                                top: position
                            }}
                        />
                    </div>
                    <div className="p-2 text-right">
                        <p className="text-sm">{outputAnchor.label}</p>
                    </div>
                </>
            )}
            {outputAnchor.type === 'options' && outputAnchor.options && outputAnchor.options.length > 0 && (
                <>
                    <div className="group">
                        {/* <div className="absolute right-0 hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2">
                            {
                                outputAnchor.options.find((opt) => opt.name === data.outputs?.[outputAnchor.name])?.type ?? outputAnchor.type
                            }
                        </div> */}
                        <Handle
                            type='source'
                            position={Position.Right}
                            id={outputAnchor.options.find((opt) => opt.name === data.outputs?.[outputAnchor.name])?.id ?? ''}
                            isValidConnection={(connection) => isValidConnection(connection, reactFlowInstance)}
                            style={{
                                height: 10,
                                width: 10,
                                backgroundColor: data.selected ? 'theme-primary-color' : 'theme-secondary-color',
                                top: position
                            }}
                        />
                    </div>
                    <div className="p-2 text-right">
                        <Dropdown
                            disabled={disabled}
                            disableClearable={true}
                            name={outputAnchor.name}
                            options={outputAnchor.options}
                            onSelect={(newValue) => {
                                setDropdownValue(newValue)
                                data.outputs[outputAnchor.name] = newValue
                            }}
                            value={data.outputs[outputAnchor.name] ?? outputAnchor.default ?? 'choose an option'}
                        />
                    </div>
                </>
            )}
        </div>
    )
}

NodeOutputHandler.propTypes = {
    outputAnchor: PropTypes.object,
    data: PropTypes.object,
    disabled: PropTypes.bool
}

export default NodeOutputHandler
